import { useIntl } from "react-intl";

import type { PaymentMethod } from "@/app/payments/types";
import { formatCurrency } from "@/utils/currency";

interface Props {
  promoCodeDiscount?: number;
  totalPrice: number;
  paymentMethod: PaymentMethod;
}

export const PaymentDetails = ({
  promoCodeDiscount,
  totalPrice,
  paymentMethod,
}: Props) => {
  const intl = useIntl();

  const getPaymentMethodLabel = (method: PaymentMethod) => {
    switch (method) {
      case "checkout":
        return intl.formatMessage({
          id: "debitCard",
          defaultMessage: "Debit Card",
        });
      case "qiAccount":
        return intl.formatMessage({ id: "qiCard", defaultMessage: "Qi" });
      case "bnpl":
        return intl.formatMessage({
          id: "payLater",
          defaultMessage: "Pay later",
        });
      default:
        return intl.formatMessage({
          id: "debitCard",
          defaultMessage: "Debit Card",
        });
    }
  };

  return (
    <div className="section-card mt-2 flex flex-col gap-2 text-sm">
      {promoCodeDiscount ? (
        <div className="flex justify-between">
          <div className="text-text-tertiary">
            {intl.formatMessage({
              id: "promoCode.promoCodeDiscount",
              defaultMessage: "Promo code discount",
            })}
          </div>
          <div className="font-bold text-core-accent-500">
            {formatCurrency(promoCodeDiscount)}
          </div>
        </div>
      ) : null}

      <div className="flex justify-between">
        <div className="text-text-tertiary">
          {intl.formatMessage({ id: "total", defaultMessage: "Total" })}
        </div>
        <div className="font-bold text-text-primary">
          {formatCurrency(totalPrice)}
        </div>
      </div>

      <div className="flex justify-between">
        <div className="text-text-tertiary">
          {intl.formatMessage({
            id: "paymentMethod",
            defaultMessage: "Payment method",
          })}
        </div>
        <div className="font-bold text-text-primary">
          {getPaymentMethodLabel(paymentMethod)}
        </div>
      </div>
    </div>
  );
};
